module.exports = __webpack_public_path__ + "h5/img/statis3.eea6603b.png";